export default function IconPaintBucket(props) {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M19 11L8.5 1.5a2 2 0 00-2.83 0l-2.17 2.17a2 2 0 000 2.83L13.5 16"/><path d="M19 11l2.5 9h-5L19 11z"/>
    </svg>
  )
}
